  <p-table #clientlist [columns]="cols" [value]="clients" [lazy]="true" (onLazyLoad)="loadLazy($event)" [paginator]="true"
           [rows]="20" [totalRecords]="totalRecords" [loading]="loading" dataKey="Id">
    <ng-template pTemplate="caption" [style]="{'height':'30px !important'}">
      <div style="height: 30px; width: 100%">
        <span class="float-left">Client List</span>
        <div class="float-right" style="margin-left: 20px;">
          <a (click)="openEdit('')" class="text-white" style="font-size:24px; cursor:pointer" *hasClaim="'Client_Edit'" title="Add Client"><i class="fa-plus fa"></i> </a>
          <a (click)="loadLazy(null)" class="text-white" style="font-size:24px; cursor:pointer; margin-left: 5px;" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i> </a>
        </div>
        <div class="float-right">
          <input pInputText type="text" (keypress)="handleSearchKey($event, clientlist)" placeholder="Client Search" />
        </div>
      </div>  
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td>
          <a style="cursor: pointer; margin-left:5px;" (click)="openEdit(rowData.Id)">
            {{rowData.Code}}
          </a>
        </td>
        <td>
          {{rowData.Name}}
        </td>
        <td>
          {{rowData.State}}
        </td>
      </tr>
    </ng-template>
  </p-table>
